import { SchedulerTypeEnum } from '@shared/enums';

export const SchedulerTypeMap: { [key in SchedulerTypeEnum]: string } = {
  [SchedulerTypeEnum.Inspection]: 'T24 Inspection',
  [SchedulerTypeEnum.Permit]: 'Permit',
  [SchedulerTypeEnum.Task]: 'Task'
}
